import React, { useState } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import PositionFormComp from '../../components/version-4/MasterForms/PositionFormcomp'
import { usePosition } from '../../hooks/CompanyConfiguration/usePosition'
import { ROUTES } from '../../shared/constants'

function PositionForm({ position }) {
  const { addPosition, loading, updatePosition } = usePosition()

  const [modules, setModules] = useState({
    ATTENDANCE: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      FLAG: false,
    },
    EMPLOYEE: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      FLAG: false,
    },
    LEAD: {
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
      FLAG: false,
    },
  })

  const [positionData, setPositionData] = useState({
    name: '',
    rank: '',
    positionCode: '',
    modulePermission: {},
    control: [],
  })

  const subModulePermissions = Object.values(modules).map((item) => {
    return [item.CREATE ? 'CREATE' : '', item.READ ? 'READ' : '', item.UPDATE ? 'UPDATE' : '', item.DELETE ? 'DELETE' : ''].filter((v) => v !== '')
  })

  const filterSubModulePermissions = subModulePermissions
  //console.log('FILTER : ', filterSubModulePermissions)
  const handlePosition = () => {
    if (position) {
      updatePosition({
        ...positionData,
        positionId: position._id,
        positionName: positionData.name,
        modulePermission: Object.keys(modules),
        control: positionData.control,
        subModulePermission: filterSubModulePermissions,
      })
    } else {
      addPosition({
        positionName: positionData.name,
        rank: positionData.rank,
        positionCode: positionData.positionCode,
        modulePermission: Object.keys(modules),
        control: positionData.control,
        subModulePermission: filterSubModulePermissions,
      })
    }
  }

  React.useEffect(() => {
    if (position) {
      setPositionData({
        name: position.positionName,
        positionCode: position.positionCode,
        rank: position.rank,
        control: position.control
      })
    }
  }, [position])
  return (
    <Layout heading="Position" heading2={position ? 'Edit' : 'Add'} url1={ROUTES.POSITION} none>
      <HeaderTabLayout
        heading="Position"
        content={<PositionFormComp state={positionData} setState={setPositionData} modules={modules} setModules={setModules} />}
        addContent={handlePosition}
        redirect={ROUTES.POSITION}
        loading={loading}
        state={positionData} setState={setPositionData}
      />
    </Layout>
  )
}

export default PositionForm